module.exports = __webpack_public_path__ + "static/media/HumanitarianHealthLogoWhiteTextHorizontal.588168e8.png";